 
import CONQUER from "../../CONQUER";
import { ACTIONS } from "../../../Models/ENUM";
import InventoryItem from "./InventoryItem";
import ARRAY from "../../../UTIL/ARRAY";
import GameInstance from "../GameInstance";
import ShopItem from "../SHOP/ShopItem";
import LOG, { log } from "../../../UTIL/LOG";
import PlayerInventory from "./PlayerInventory";
import ShopTab from "../SHOP/ShopTab";

class InventoryTab
{
    public items            : any = [];
    public unlocked         : any = [];
    public locked           : any = [];

    private inventory       : PlayerInventory;
 
    public tabKey           : string;
    public title            : string;
    public symbol           : string;
    public color            : string;
    public description      : string;
    public sorting          : number;

    constructor( inventory:PlayerInventory, tabKey:string )
    {
        this.inventory          = inventory;
        this.tabKey             = tabKey;
 
        let shopTab : ShopTab   = inventory.gameInstance.Shop.tabs[ tabKey ] || {};
  
        this.title              = shopTab.title;
        this.description        = shopTab.description;
        this.symbol             = shopTab.symbol || "Symbol_"+tabKey;
        this.color              = shopTab.color;
        this.sorting            = shopTab.sorting;
    }

    public push( inventoryItem:InventoryItem )
    {
        this.items.push( inventoryItem );
        if( inventoryItem.isSelected ) this.inventory.selected[ this.tabKey ] = inventoryItem.key;

        if( !inventoryItem.isLocked )
        {
            this.unlocked.push( inventoryItem );
        }else{
            this.locked.push( inventoryItem );
        }
    }

    public checkSelect()
    {
        //log("========== TAB", this.tabKey, "checkSelect", this.items[0] != undefined );
        if( !this.items[0] ) return;

        if( this.items[0].sorting ) this.items = ARRAY.sort( this.items, "sorting" );

        //log("TAB SELECTED?", this.tabKey, this.inventory.selected[ this.tabKey ] );
 
        if( this.inventory.selected[ this.tabKey ] ) return;

        for( let n in this.items ) if( !this.items[n].isLocked ) return this.select( this.items[n].key );
        
        //log("NOTHING SELECTED, DO IT" );

        this.items[0].unlock();
        this.select( this.items[0].key );
    }

    public select( key:string )
    {
        //log("== TAB", this.tabKey, "SELECT", key );
        //log( "=== tab select", shopItemKey, "current", this.inventory.selected[ this.tabKey ] );

       // if( this.inventory.selected[ this.tabKey ] == shopItemKey ) return;
 
        let current : InventoryItem = this.inventory.getItem( key );
        
       // log("current!", current );
        
        if( current && this.inventory.selected[ this.tabKey ] != key ) current.select();

        this.inventory.selected[ this.tabKey ] = key;
 
        for( let n in this.items )
        {
          //  log("n", n )
            let inventoryItem : InventoryItem = this.items[n];
            if( inventoryItem != current ) inventoryItem.deselect();
        }
  
    }
 
 
}

export default InventoryTab;